<template>
  <div class="chat-box">
    <img class="avatar" :src="avatarUrl || defaultUrl" />
    <span class="text">
      <slot />
    </span>
  </div>
</template>

<script>
export default {
  name: "ChatBox",
  props: ["avatarUrl"],
  data: function() {
    return {
      defaultUrl: this.$i18n.t("general.chatBoxImage.url")
    };
  }
};
</script>

<style scoped lang="scss">
.chat-box {
  max-width: 600px;
  display: flex;
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 30px;

  .avatar {
    border-radius: 100px;
    width: 61px;
    min-width: 61px;
    height: 61px;
    min-height: 61px;
    border: 3px solid var(--secondary-green);
    margin-right: 15px;
  }

  .text {
    position: relative;
    font-family: var(--font-default);
    text-align: left;
    background: var(--speechbubble-background);
    font-size: 18px;
    color: var(--speechbubble-text);
    padding: 15px 30px 30px 30px;
    border-radius: 8px;
  }
}

.text:before {
  content: " ";
  display: block;
  position: absolute;
  left: -7px;
  top: 18px;
  width: 15px;
  height: 15px;
  background-color: var(--speechbubble-background);
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
}
</style>
